import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import { ajax } from "jquery";
import extend from "extend";

export default class DiscountsController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
    }

    onRemove(discount) {
        ajax(this.props.removeUrl, {
            data: { id: discount.id },
            method: "POST",
            dataType: "json",
            success: (data) => {
                this.store.load(extend({
                    feedback: {
                        message: data.message,
                        type: data.type,
                    },
                }, data.basket));
            },
        });
    }

    render() {
        const DiscountView = ComponentRegistry.get(this.props.itemView);
        const DiscountListView = ComponentRegistry.get(this.props.view);

        const items = Object.values(this.props.items).map(discount => <DiscountView
          key={discount.id}
          item={discount}
          labels={this.props.labels}
          onRemove={() => this.onRemove(discount)}
        />);

        return (
          <DiscountListView>{items}</DiscountListView>
        );
    }
}

DiscountsController.propTypes = {
    store: React.PropTypes.string,
    view: PropTypes.string.isRequired,
    itemView: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
    })).isRequired,
    labels: PropTypes.shape({}).isRequired,
    removeUrl: PropTypes.string.isRequired,
};

DiscountsController.defaultProps = {
    view: "BasketViewsDiscountListView",
    itemView: "BasketViewsDiscountView",
};




// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Controllers/DiscountsController.jsx